export const roundPercentagesToTotal = (percentages: number[]): number[] => {
	if (percentages.length === 0) return [];

	const total = percentages.reduce((sum, val) => sum + val, 0);

	if (total === 0) return percentages.map(() => 0);

	const rawPercentages = percentages.map((value) => (value / total) * 100);
	const roundedPercentages = rawPercentages.map(Math.floor);

	let remainder = 100 - roundedPercentages.reduce((sum, val) => sum + val, 0);

	while (remainder > 0) {
		for (let i = 0; i < roundedPercentages.length; i++) {
			if (remainder === 0) break;
			roundedPercentages[i]++;
			remainder--;
		}
	}

	return roundedPercentages;
};
